import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import User from '../views/pages/User.vue'
import Car from '../views/pages/Car.vue'
import Admin from '../views/pages/Admin.vue'
import AdminLog from '../views/pages/AdminLog.vue'
import AppLog from '../views/pages/AppLog.vue'
import Sensor from '../views/pages/Sensor.vue'
import SysLog from '../views/pages/SysLog.vue'
import File from '../views/pages/File.vue'
import UserInfo from '../views/pages/UserInfo.vue'
import i18n from '../lang'
import Guide from "../views/pages/Guide.vue";



Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routes = [{
		path: '/',
		name: 'Login',
		component: Login,
		hidden: true
	},
	{
		path: '/guide',
		name: 'Guide',
		component: Guide,
		hidden: true
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		hidden: true,
		children:[
			{
				path: '/user',
				name: '用户数据管理',
				component: User
			},
			{
				path: '/car',
				name: '车型库管理',
				component: Car
			},
			{
				path: '/sensor',
				name: '传感器数据管理',
				component: Sensor
			},
			{
				path: '/appLog',
				name: 'App日志管理',
				component: AppLog
			},
			{
				path: '/sysLog',
				name: '系统日志管理',
				component: SysLog
			},
			{
				path: '/adminLog',
				name: '管理员日志管理',
				component: AdminLog
			},
			{
				path: '/admin',
				name: '管理员数据管理',
				component: Admin
			},
			{
				path: '/file',
				name: '文件管理',
				component: File
			},
			{
				path: '/userInfo',
				name: '个人管理',
				component: UserInfo
			}
			
		]
	}
]

const router = new VueRouter({
	routes
})

export default router
